<template>
	<div class="plugins-delivery-container" v-if="!isIOS()">
		<div class="subscribe-title-container" v-if="userStore.currSubscription === 'base'">
			<div class="texts-container">
				<div class="choose-plan">{{ getString('switch_to_new_plan') }}</div>
				<div class="first-month-free">{{ getString('preserve_your_credit') }}</div>
				<div class="nothing-charged">{{ getString('preserve_credit_info') }}</div>
			</div>
		</div>
		<MarketplaceCardSlashed
			v-if="userIsSubscribedOld"
			@go-to-portal="clickGoToPortal"
			@update-billing-cycle="clickUpdateBillingCycle"
			@switch-to-new-plan="openSwitchToNewPlanPopup"
			ref="card-slashed"
			:marketplaceItems="marketplaceItems"
			:billingCycle="billingCycle"
			:loading-sub="loadingCycle || loadingNewPlan"
			class="mb-20"
		/>
		<MarketplaceNewSubscriptionCards :loading="loadingCycle || loadingNewPlan" @switch-plan="openSwitchToNewPlanPopup" @checkout="startCheckout" />
		<PluginsExternalCard />
		<AppPopup ref="popup-confirm-cycle" :title="getString('change_billing_cycle')" :body-text="getString('change_billing_cycle_confirm', [this.userStore.currBusiness && this.userStore.currBusiness.plan_cycle === 'month' ? this.getString('monthly') : this.getString('yearly'), this.userStore.currBusiness && this.userStore.currBusiness.plan_cycle === 'month' ? this.getString('yearly') : this.getString('monthly')])" :buttons="[{text: getString('cancel'), negative: true}, {text: getString('continue'), callback: updateBillingCycle, loading: loadingCycle}]" />
		<AppPopup ref="popup-confirm-new-plan" :title="getString('change_plan')" :body-text="getString('change_plan_confirm', [getString('qromo_'+userStore.currSubscription), getString('qromo_'+newTargetPlan)])" :buttons="[{text: getString('cancel'), negative: true, loading: loadingNewPlan}, {text: getString('continue'), callback: switchToNewPlan, loading: loadingNewPlan}]" />
		<CheckoutInPlace :client-secret="clientSecret" @toggling-popup="togglingPopupCheckout" @checkout-complete="refreshBusiness" />
	</div>
	<div class="ios-warning" v-else>
		<p>{{ getString('ios_marketplace_warning') }}</p>
	</div>
</template>

<script>
import {useLanguageStore, useNotificationStore, useCurrencyStore, useSvgStore} from "@/shared/stores";
import {useUserStore, useFunnelStore, useMarketplaceStore} from "@/console-new/stores";
import API from "@/shared/helpers/API";
import AppTabsSwitch from "@/shared/components/AppTabsSwitch.vue";
import AppPopup from "@/shared/components/AppPopup.vue";
import MarketplaceNewSubscriptionCards from "@/console-new/components/plugins/MarketplaceNewSubscriptionCards.vue";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import CheckoutInPlace from "@/console-new/components/shared/CheckoutInPlace.vue";
import MarketplaceCardSlashed from "@/console-new/components/plugins/MarketplaceCardSlashed.vue";
import PluginsExternalCard from "@/console-new/components/plugins/PluginsExternalCard.vue";
import {isIOS} from "@/shared/helpers/webapp";
import AppButton from "@/shared/components/AppButton.vue";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		let svgStore = useSvgStore();
		let marketplaceStore = useMarketplaceStore();
		const notificationStore = useNotificationStore();
		const currencyStore = useCurrencyStore();
		const funnelStore = useFunnelStore();
		return {getString: languageStore.getString, marketplaceStore, currencyStore, showNotification: notificationStore.showNotification, funnelStore, userStore, getIcon: svgStore.get}
	},
	name: "PluginsMarketplace",
	components: {
		AppButton,
		CheckoutInPlace, AppBottomSheet, AppPopup, MarketplaceNewSubscriptionCards, AppTabsSwitch, MarketplaceCardSlashed, PluginsExternalCard},
	data() {
		return {
			billingCycle: this.userStore.currBusiness && this.userStore.currBusiness.plan_cycle && this.userStore.currBusiness.plan_cycle === 'month' ? 1 : 0,
			loadingCycle: false,
			loadingNewPlan: false,
			clientSecret: null,
			newTargetPlan: null,
			fromPlan: null,
			toPlan: null,
			changeCycle: false,
		}
	},
	methods: {
		isIOS() {
			return isIOS();
		},
		startCheckout(secret, billingCycle, planName) {
			this.clientSecret = secret;
			let value = 0;
			if(planName && planName !== 'free') {
				let subPrices = this.currencyStore.currCurrency?.prices?.plans[planName];
				let finalVal = billingCycle === 0 ? (subPrices?.yearMonth * 12) : subPrices?.month;
				value = Number(finalVal || 0);
			}
		},
		togglingPopupCheckout(isOpen) {
			if (!isOpen) {
				this.clientSecret = null;
			}
		},
		refreshBusiness() {
			setTimeout(() => {
				const subActive = this.userStore.currBusiness && this.userStore.currBusiness.plan_id;
				this.userStore.refreshBusiness(this.userStore.currBusinessId, () => {
					if(!subActive && this.userStore.currBusiness && this.userStore.currBusiness.plan_id) {

						let value = 0;
						if(this.userStore?.currSubscription && this.userStore?.currSubscription !== 'free') {
							let subPrices = this.currencyStore.currCurrency?.prices?.plans[this.userStore?.currSubscription];
							let finalVal = this.userStore.currBusiness.plan_cycle === 'month' ? subPrices?.month : (subPrices?.yearMonth * 12);
							value = Number(finalVal || 0);
						}

					}
				});
			}, 2000);
			setTimeout(() => {
				this.clientSecret = null;
			}, 2500);
		},
		clickGoToPortal() {
			if(this.$refs?.['card-slashed']) {
				this.$refs['card-slashed'].loading = true;
			}
			API.init().getStripeCustomerPortal((r) => {
				if (r && typeof r === 'object' && r.url) {
					location.replace(r.url);
					setTimeout(() => {
						if(this.$refs?.['card-slashed']) {
							this.$refs['card-slashed'].loading = false;
						}
					}, 1000);
				} else {
					if(this.$refs?.['card-slashed']) {
						this.$refs['card-slashed'].loading = false;
					}
					this.showNotification('generic-fail');
				}
			});
		},
		switchToNewPlan() {
			if(this.loadingNewPlan) {
				return;
			}
			if(this.$refs?.['card-slashed']) {
				this.$refs['card-slashed'].loading = true;
			}
			this.loadingNewPlan = true;
			API.init().stripeSubscriptionUpdate(this.userStore.currBusinessId, this.newTargetPlan, this.changeCycle, (r) => {
				if (r && typeof r === 'object' && r.result === 'OK') {
					setTimeout(() => {
						if(this.$refs?.['card-slashed']) {
							this.$refs['card-slashed'].loading = false;
						}
						this.$refs["popup-confirm-new-plan"].toggleStatus(false);
						this.userStore.refreshBusiness(this.userStore.currBusinessId, () => {
							this.loadingNewPlan = false;
						});
					}, 1000);
				} else {
					this.$refs["popup-confirm-new-plan"].toggleStatus(false);
					if(this.$refs?.['card-slashed']) {
						this.$refs['card-slashed'].loading = false;
					}
					if(r?.details === 'too_many_users') {
						let maxUsers = this.newTargetPlan === 'basic' ? 3 : 10;
						maxUsers = this.newTargetPlan === 'free' ? 1 : maxUsers;
						this.showNotification('too-many-users', [maxUsers]);
					} else if(r?.details === 'no_webhooks') {
						this.showNotification('no-webhooks-edit');
					} else if(r?.details === 'cannot_change_unpaid') {
						this.showNotification('cannot-change-update');
					} else if(r?.details === 'max_webhooks') {
						this.showNotification('max-webhooks-edit', [1]);
					} else if(r?.details === 'currency_mismatch') {
						this.showNotification('user-currency-mismatch', [this.userStore?.user?.name]);
					} else {
						this.showNotification('generic-fail');
					}
					this.loadingNewPlan = false;
				}
			});
		},
		openSwitchToNewPlanPopup(newPlan, changeCycle = false) {
			this.newTargetPlan = newPlan;
			this.changeCycle = changeCycle;
			this.$refs["popup-confirm-new-plan"].toggleStatus();
		},
		clickUpdateBillingCycle() {
			this.$refs["popup-confirm-cycle"].toggleStatus();
		},
		updateBillingCycle() {

			this.loadingCycle = true;
			let newCycle =this.userStore.currBusiness && this.userStore.currBusiness.plan_cycle && this.userStore.currBusiness.plan_cycle === 'month' ? 'year' : 'month';
			API.init().stripeSubscriptionCycleUpdate(this.userStore.currBusinessId, newCycle, (response) => {
				this.userStore.refreshBusiness(this.userStore.currBusinessId,() => {
					this.loadingCycle = false;
					if (response && response.result === "OK") {
						this.$refs["popup-confirm-cycle"].toggleStatus(false);
						this.showNotification('generic-success');
						this.billingCycle = newCycle === 'month' ? 1 : 0;
					} else {
						this.showNotification('generic-fail');
					}
				});
			});
		},
		hidePopup() {
			this.$refs["popup-confirm-cycle"].toggleStatus(false);
		},
		checkStoreOpenSection() {
			if(this.marketplaceStore?.shouldOpen) {
				if(this.marketplaceStore?.showPluginNotification) {
					this.showLockedNotification(this.marketplaceStore.shouldOpen);
					this.marketplaceStore.showPluginNotification = false;
				}
				this.marketplaceStore.shouldOpen = null;
			}
		},
		showLockedNotification(section) {
			let finalSub = this.getString('qromo_basic');
			if(section === 'subscription' || section === 'pos' || section === 'counter') {
				this.showNotification('forbidden-missing-subscription');
				return
			} else if(section === 'pro' || section === 'delivery' || section === 'takeaway' || section === 'order_pay') {
				finalSub = this.getString('qromo_pro');
			} else if(section === 'kitchen_monitor' || section === 'reservations') {
				finalSub = this.getString('qromo_allinone');
			}
			this.showNotification('forbidden-missing-functionality', [finalSub]);
		},
	},
	computed: {
		userIsSubscribedOld() {
			return this.userStore && this.userStore.currBusiness && this.userStore.currBusiness.plan_id && this.userStore.currSubscription === 'base';
		},
		marketplaceItems() {
			return [{
				id: "order_pay",
				title: this.getString('order_and_pay'),
				subtitle: this.getString('order_pay_marketplace_subtitle', [this.userStore.menuWord]),
				url: URL_HTML+'/ordini-pagamenti/',
				icon: 'iconOrderPay',
				beta: false,
                countryAvailable: CAPABILITIES.includes('order_pay'),
				price: this.billingCycle === 0 ? 4 : 6,
				active: false,
				colorStart: 'var(--color-danger)',
				colorEnd: 'var(--color-primary)',
				selected: this.userStore.currPlans.order_pay,
				customSlot: 'plugin-heading',
				dropdownSlot: 'plugin-dropdown',
				features: [
					this.getString('order_pay_feature_1'),
					this.getString('order_pay_feature_2'),
					this.getString('order_pay_feature_3'),
					this.getString('order_pay_feature_4'),
					this.getString('order_pay_feature_5')
				],
				requirements: [
					{
						colorStart: 'var(--color-secondary)',
						icon: 'iconQromoBase',
					}
				],
			}, {
				id: "counter",
				title: this.getString('counter'),
				subtitle: this.getString('counter_marketplace_subtitle'),
				icon: 'iconCounterSales',
				beta: false,
				countryAvailable: CAPABILITIES.includes('counter'),
				price: this.billingCycle === 0 ? 20 : 30,
				active: false,
				features: [
					this.getString('counter_feature_1'),
					this.getString('counter_feature_2'),
					this.getString('counter_feature_5'),
					this.getString('counter_feature_4'),
				],
				colorStart: '#e36e28',
				colorEnd: 'var(--color-primary)',
				selected: this.userStore.currPlans.counter,
				customSlot: 'plugin-heading',
				dropdownSlot: 'plugin-dropdown',
				requirements: [
					{
						colorStart: 'var(--color-secondary)',
						icon: 'iconQromoBase',
					}
				],
			}, {
				id: "pay_bill",
				title: this.getString('pay_bill'),
				subtitle: this.getString('pay_bill_subtitle'),
				url: URL_HTML+'/',
				icon: 'iconPayBill',
				beta: false,
                countryAvailable: CAPABILITIES.includes('order_pay'),
				price: this.billingCycle === 0 ? 4 : 6,
				active: false,
				features: [
					this.getString('future_pay_bill_1'),
					this.getString('future_pay_bill_2'),
					this.getString('future_pay_bill_3'),
					this.getString('future_pay_bill_4'),
				],
				requirements: [
					{
						colorStart: 'var(--color-secondary)',
						icon: 'iconQromoBase',
					}
				],
				colorStart: '#00B96C',
				colorEnd: 'var(--color-primary)',
				selected: this.userStore.currPlans.pay_bill,
				customSlot: 'plugin-heading',
				dropdownSlot: 'plugin-dropdown'
			}, {
				id: "delivery",
				title: this.userStore.deliveryWord,
				subtitle: this.getString('delivery_x_marketplace_subtitle', [this.userStore.deliveryWord]),
				url: URL_HTML+'/delivery/',
				icon: 'iconDelivery',
				beta: false,
                countryAvailable: CAPABILITIES.includes('delivery'),
				price: this.billingCycle === 0 ? 2 : 3,
				active: false,
				features: [
					this.getString('max_distance'),
					this.getString('preparing_time'),
					this.getString('scheduled_delivery'),
					this.getString('courier_delivery'),
					this.getString('additional_costs'),
				],
				requirements: [
					{
						colorStart: 'var(--color-secondary)',
						icon: 'iconQromoBase',
					},
					{
						colorStart: 'var(--color-danger)',
						icon: 'iconOrderPay',
					}
				],
				colorStart: '#03C6F3',
				colorEnd: 'var(--color-primary)',
				selected: this.userStore.currPlans.delivery,
				customSlot: 'plugin-heading',
				dropdownSlot: 'plugin-dropdown'
			}, {
				id: "takeaway",
				title: this.userStore.takeawayWord,
				subtitle: this.getString('takeaway_marketplace_subtitle'),
				url: URL_HTML+'/asporto/',
				icon: this.userStore.currBusiness && this.userStore.currBusiness.type === "other" ? "iconTakeawayOther" : "iconTakeaway",
				beta: false,
                countryAvailable: CAPABILITIES.includes('takeaway'),
				price: this.billingCycle === 0 ? 2 : 3,
				active: false,
				features: [
					this.getString('x_timetables', [this.userStore.takeawayWord]),
					this.getString('additional_costs'),
					this.getString('scheduled_order_days_advance'),
					this.getString('cash_payment'),
				],
				requirements: [
					{
						colorStart: 'var(--color-secondary)',
						icon: 'iconQromoBase',
					},
					{
						colorStart: 'var(--color-danger)',
						icon: 'iconOrderPay',
					}
				],
				colorStart: '#FDC700',
				colorEnd: 'var(--color-primary)',
				selected: this.userStore.currPlans.takeaway,
				customSlot: 'plugin-heading',
				dropdownSlot: 'plugin-dropdown'
			}, {
				id: "pos",
				title: this.getString('pos'),
				subtitle: this.getString('pos_marketplace_subtitle'),
				icon: 'iconPos',
				beta: false,
                countryAvailable: CAPABILITIES.includes('order_pay'),
				price: 0,
				active: false,
				features: [
					this.getString('pos_feature_1'),
					this.getString('pos_feature_2'),
					this.getString('pos_feature_3'),
					this.getString('pos_feature_4'),
				],
				colorStart: '#8F4DFE',
				colorEnd: 'var(--color-primary)',
				selected: this.userStore.currPlans.pos,
				customSlot: 'plugin-heading',
				dropdownSlot: 'plugin-dropdown'
			}];
		}
	},
	mounted() {
		this.checkStoreOpenSection();
	},
	watch: {
		'userStore.currBusiness': {
			handler: function (val, oldVal) {
				if (val && val !== oldVal) {
					this.billingCycle = val.plan_cycle && val.plan_cycle === "month" ? 1 : 0;
				}
			},
		},
		'marketplaceStore.shouldOpen': function (newVal, oldVal) {
			if (newVal !== oldVal) {
				this.checkStoreOpenSection();
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.plugins-delivery-container {
	padding-bottom: 30px;

	max-width: 1400px;
	margin: 0 auto;

	.subscribe-title-container {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;

		.requirement-tag {
			@include centered;
			position: relative;
			padding: 12px;
			background: linear-gradient(225deg, var(--color-secondary) 0%, var(--color-primary) 100%) 0% 0% no-repeat;
			border-radius: 7px;

			&:deep(svg)	{
				height: 28px;
				width: 28px;
				.fill { fill: var(--color-bg); }
				.stroke { stroke: var(--color-bg); }
			}

			@media (max-width: 600px) {
				margin-bottom: 15px;
			}
		}

		.texts-container {
			display: flex;
			flex-direction: column;
			align-items: center;

			.choose-plan {
				font-size: 22px;
				font-weight: 700;
				color: $primary;
				margin-bottom: 10px;
				text-align: center;

				&.noTrial {
					margin-bottom: 25px;
				}

				@media (max-width: 420px) {
					font-size: 20px;
				}

			}

			.first-month-free {
				font-weight: 700;
				font-size: 18px;
				color: $danger;
				margin-bottom: 4px;
				text-align: center;

				@media (max-width: 420px) {
					font-size: 16px;
				}
			}

			.nothing-charged {
				font-size: 13px;
				color: $danger;
				margin-bottom: 30px;
				text-align: center;

				@media (max-width: 420px) {
					font-size: 12px;
				}
			}
		}


		@media (max-width: 600px) {
			flex-direction: row;
			justify-content: center;
			align-items: flex-start;

			.texts-container {
				align-items: flex-start;
				padding-left: 20px;

				.choose-plan {
					margin-top: 0;
					margin-bottom: 6px;
					text-align: left;
				}

				.first-month-free {
					text-align: left;
				}

				.nothing-charged {
					margin-bottom: 20px;
					text-align: left;
				}
			}
		}

	}

	:deep(.card-container .card-body) {
		padding: 0;
		& > .list-container {
			.list-item:first-child::before {
				display: none;
			}

			.list-item:last-child::after {
				display: none;
			}
		}
	}

	:deep(.slashed-card-container) {

		@media (max-width: 768px), (min-width: 921px) and (max-width: 1080px) {
			flex-direction: column;

			.slashed-left, .slashed-right {
				width: 100%;
			}

			.slashed-left {
				border-top-right-radius: 13px;
				border-bottom-left-radius: 0;
				padding-right: 0;
				min-height: 130px;
				padding-bottom: 30px;

				&::after {
					top: unset;
					right: unset;
					left: 0;
					bottom: -15px;
					width: 100%;
					height: 30px;
					background-color: var(--color-bg);
					transform: skewy(-2deg);
				}
			}

			.slashed-right {
				border-top-left-radius: 0;
				border-bottom-right-radius: 13px;
			}
		}
	}
}
.billing-cycle-container {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	margin-bottom: 25px;

	.billing-cycle-title {
		font-size: 18px;
		font-weight: 700;
		color: $primary;
		margin-bottom: 10px;
	}

	.billing-cycle-description {
		font-size: 14px;
		color: var(--color-txt);
		margin-bottom: 10px;
		text-align: center;
	}

	.billing-cycle-save {
		font-size: 11px;
		font-weight: 500;
		color: $primary;
		background-color: #C7C8CAFF;
		padding: 4px 12px;
		border-radius: 28px;
		margin-top: 10px;
		margin-right: 100px;
		opacity: 0.5;
		transition: opacity 0.3s ease-in-out, background-color 0.3s ease-in-out;

		&.active {
			background-color: rgba(44, 236, 190, 0.5);
			opacity: 1;
		}
	}

	:deep(.switch-container) {
		p {
			font-size: 12px;
		}
	}
}
.ios-warning {
	display: flex;
	justify-content: center;
}
</style>